<template>
    <div class="w-full">
        <!-- Formulario oculto para enviar los datos al backend -->
        <form ref="pdfForm" method="POST" target="print_iframe" style="display: none" :enctype="enctype"
            :action="action_post">
            <textarea name="codigo" v-model="allHtml" style="display: none;"></textarea>
            <textarea name="params" v-model="paramsPDF" style="display: none;"></textarea>
            <input v-if="token_local" type="hidden" name="token" :value="token_local">
        </form>

        <div class="denuncia-print-placeholder" v-if="isLoading">
            <div class="loading-container">
                <ProgressSpinner style="width: 50px; height: 50px;" strokeWidth="5" fill="#EEEEEE"
                    animationDuration="1.5s" class="loading-spinner" />
                <div class="loading-text">Cargando diligencia...</div>
            </div>
        </div>

        <iframe name="print_iframe" frameborder="0"></iframe>
    </div>
</template>

<script>
import ProgressSpinner from "primevue/progressspinner";
import { mapGetters, mapState } from "vuex";

export default {
    props: {
        DiligenciaID: {
            type: String,
            default: null,
        },
    },
    components: {
        ProgressSpinner
    },
    data() {
        return {
            allHtml: "",
            paramsPDF: "{}",
            isPreviewVisible: false,
            isLoading: true, // Nuevo estado para el loader
            enctype: "text/plain",
            token_local: "",
            action_post: process.env.VUE_APP_BACKEND_ENVIRONMENT + "/print/"
        };
    },
    computed: {
        ...mapGetters({
            getDiligenciaByArrId: "sumario/diligencia/getDiligenciaByArrId",
            viewData: "sumarioViews/getViewData",
        }),
        ...mapState({
            sumario: (state) => state.sumario,
            user: (state) => state.user,
            diligenciasList: (state) => state.siis.tipoDiligencia,
            views: (state) => state.sumarioViews,
        }),
    },
    mounted(){
        if (this.DiligenciaID) {
            this.loadAndPreviewDiligencia();
        }
    },
    watch: {
        DiligenciaID(newValue) {
            if (!newValue) return;
            this.loadAndPreviewDiligencia();
        },
    },
    methods: {
        loadAndPreviewDiligencia() {
            const respuesta = this.sumario.diligencia[0];
            if (!respuesta || !respuesta.Contenido) {
                this.isLoading = false;
                this.isPreviewVisible = false;
                return;
            }
            const txt = document.createElement("textarea");
            txt.innerHTML = respuesta.Contenido;
            this.allHtml = txt.value;

            this.previewPDF();
        },
        previewPDF() {
            let config = {
                "margin-top": 12.5,
                "margin-bottom": 34.7,
                "margin-left": 35,
                "margin-right": 11,
                "pageSize": "Legal",
            };

            this.paramsPDF = JSON.stringify(config);

            this.$nextTick(() => {
                this.$refs.pdfForm.submit();
                this.isPreviewVisible = true;
                this.isLoading = false; // Ocultar el loader cuando se renderiza el PDF
            });
        }
    }
};
</script>

<style scoped>
.denuncia-print-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100vh - 120px);
    position: relative;
    text-align: center;
}

.denuncia-print-placeholder::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/diligencia.png");
    background-size: cover;
    filter: brightness(0.4);
}

.loading-container {
    display: flex;
    align-items: center;
    z-index: 1;
    background: rgba(0, 0, 0, 0.6);
    padding: 15px 20px;
    border-radius: 10px;
}

.loading-text {
    font-size: 20px;
    margin-left: 10px;
    color: white;
    z-index: 2;
    position: relative;
}

iframe {
    width: 100%;
    height: 600px;
    border: none;
}
</style>
